/**
 * Data URL placeholder image to avoid 404 errors
 * This is a base64-encoded SVG that displays a gray placeholder
 */
export const PLACEHOLDER_IMAGE =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjMzc0MTUxIi8+CjxwYXRoIGQ9Ik0xNjAgMTIwSDI0MFYxODBIMTYwVjEyMFoiIGZpbGw9IiM0QjU1NjMiLz4KPHBhdGggZD0iTTE4MCAxNDBIMjIwVjE2MEgxODBWMTQwWiIgZmlsbD0iIzZCNzI4MCIvPgo8L3N2Zz4=';
